"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityGraph = exports.EntityGraphDefaultProps = exports.isGraphNode = exports.isGraphLink = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var lodash_1 = require("lodash");
var theme_2 = require("@shapeable/theme");
require("../../fonts/shapeable/style.css");
var use_theme_1 = require("../../hooks/use-theme");
var truncate_words_1 = require("../../utils/truncate-words");
var use_entities_1 = require("../../hooks/use-entities");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
var title_case_1 = require("../../utils/title-case");
var use_full_screen_state_1 = require("../../hooks/use-full-screen-state");
var use_dimensions_1 = require("../../hooks/use-dimensions");
var entity_toggle_1 = require("./entity-toggle");
var icon_button_1 = require("../elements/icon-button");
var react_idle_timer_1 = require("react-idle-timer");
var fonts_1 = require("../../fonts");
var react_force_graph_2d_1 = __importDefault(require("react-force-graph-2d"));
var entity_tooltip_1 = require("./entity-tooltip");
var alert_message_1 = require("../elements/alert-message");
var is_valid_image_url_1 = require("../../utils/is-valid-image-url");
/**
 * Draws a rounded rectangle using the current state of the canvas.
 * If you omit the last three params, it will draw a rectangle
 * outline with a 5 pixel border radius
 */
var roundRect = function (ctx, x, y, width, height, radius, fill, stroke) {
  var cornerRadius = {
    upperLeft: 0,
    upperRight: 0,
    lowerLeft: 0,
    lowerRight: 0
  };
  if (typeof stroke == "undefined") {
    stroke = true;
  }
  if (typeof radius === "object") {
    for (var side in radius) {
      cornerRadius[side] = radius[side];
    }
  } else if (typeof radius === "number") {
    cornerRadius = {
      upperLeft: radius,
      upperRight: radius,
      lowerLeft: radius,
      lowerRight: radius
    };
  }
  ctx.beginPath();
  ctx.moveTo(x + cornerRadius.upperLeft, y);
  ctx.lineTo(x + width - cornerRadius.upperRight, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + cornerRadius.upperRight);
  ctx.lineTo(x + width, y + height - cornerRadius.lowerRight);
  ctx.quadraticCurveTo(x + width, y + height, x + width - cornerRadius.lowerRight, y + height);
  ctx.lineTo(x + cornerRadius.lowerLeft, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - cornerRadius.lowerLeft);
  ctx.lineTo(x, y + cornerRadius.upperLeft);
  ctx.quadraticCurveTo(x, y, x + cornerRadius.upperLeft, y);
  ctx.closePath();
  if (stroke) {
    ctx.stroke();
  }
  if (fill) {
    ctx.fill();
  }
};
var pathEllipse = function (ctx, x, y, w, h) {
  var kappa = 0.5522848,
    ox = w / 2 * kappa,
    oy = h / 2 * kappa,
    xe = x + w,
    ye = y + h,
    xm = x + w / 2,
    ym = y + h / 2;
  ctx.beginPath();
  ctx.moveTo(x, ym);
  ctx.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
  ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
  ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
  ctx.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
  ctx.closePath();
};
var linkItem = function (_a) {
  var theme = _a.theme,
    entities = _a.entities,
    linkItemOptions = _a.linkItemOptions;
  return function (edgeInfo) {
    var id = edgeInfo.id,
      data = edgeInfo.data,
      id1 = edgeInfo.id1,
      id2 = edgeInfo.id2,
      isImplicit = edgeInfo.isImplicit;
    var lineColor = (0, lodash_1.get)(theme, 'color.primary', '#CCC');
    var showImplicitLabels = linkItemOptions.showImplicitLabels;
    var entityTypeName = data && data.type;
    var label = edgeInfo.label;
    return {
      id: id,
      id1: id1,
      id2: id2,
      sortKey: "".concat(data.type).concat(label),
      type: data.type,
      kind: 'edge',
      label: {
        text: isImplicit && !showImplicitLabels ? '' : (label || '').toUpperCase(),
        fontSize: 10
      },
      lineStyle: 'dotted',
      color: lineColor,
      width: 2,
      data: data
    };
  };
};
var nodeItem = function (_a) {
  var theme = _a.theme,
    sid = _a.sid,
    highlightEntityTypeNames = _a.highlightEntityTypeNames,
    dagMode = _a.dagMode;
  return function (nodeInfo) {
    var _a = nodeInfo.data,
      data = _a === void 0 ? {} : _a,
      openGraph = nodeInfo.openGraph,
      label = nodeInfo.label,
      image = nodeInfo.image,
      id = nodeInfo.id,
      color = nodeInfo.color;
    var level = data.level || 1;
    var lineColor = (0, lodash_1.get)(theme, 'color.primary', '#CCC');
    var lineMidColor = (0, lodash_1.get)(theme, 'color.line', '#CCC');
    var nodeEntityTypeName = data.entityTypeName;
    var isHighlighted = (0, lodash_1.includes)(highlightEntityTypeNames, nodeEntityTypeName);
    var isCurrent = id === sid || isHighlighted;
    var imageObject;
    if (image && image.url) {
      imageObject = new Image();
      imageObject.src = image.url;
    }
    return {
      id: id,
      neighbors: [],
      links: [],
      entityTypeLabel: nodeInfo.entityTypeLabel,
      type: data.entityTypeName,
      entityTypeName: data.entityTypeName,
      sortKey: "".concat(data.entityTypeName).concat(label),
      kind: 'node',
      isCurrent: isCurrent,
      border: !!image && {
        color: isHighlighted ? lineColor : lineMidColor,
        width: 1
      },
      nodeColor: color,
      color: 'transparent',
      data: __assign(__assign({}, data), {
        group: isCurrent ? null : data.group
      }),
      image: image && image.url,
      imageWidth: image && image.width,
      imageHeight: image && image.height,
      imageObject: imageObject,
      cutout: true,
      label: {
        backgroundColor: 'transparent',
        text: (0, truncate_words_1.truncateWords)(label, {
          max: dagMode === "td" ? 2 : 5
        }),
        center: false
      },
      openGraph: openGraph,
      size: level === 0 ? 2 : isCurrent ? 1.25 : 1 - 0.1 * level
    };
  };
};
var drawNode = function (_a) {
  var theme = _a.theme,
    depth = _a.depth,
    hoverNode = _a.hoverNode,
    highlightNodes = _a.highlightNodes,
    entities = _a.entities,
    sid = _a.sid;
  return function (node, ctx, globalScale) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var globalScaleWithMax = Math.min(globalScale, 12.5);
    var label = node.label.text;
    var iconLabel = fonts_1.ShapeableFont[node.entityTypeName] || "\uE93c";
    var iconFontSize = 0.5 * globalScaleWithMax * node.size;
    var entityTypeLabel = node.entityTypeLabel || entities[node.entityTypeName] && entities[node.entityTypeName].label && entities[node.entityTypeName].label.toUpperCase();
    var imageStyle = entities[node.entityTypeName] && entities[node.entityTypeName].imageStyle;
    // measure the icon
    ctx.font = "".concat(iconFontSize, "px shapeable");
    var iconWidth = ctx.measureText(iconLabel).width;
    var NODE_R = iconWidth / 2 + 0.1;
    var isActiveNode = node.isCurrent;
    var isGroupNode = !!node.data.isGroupNode;
    var isActiveGroupNode = !!node.data.isActiveGroupNode;
    var isFaded = highlightNodes.size && !highlightNodes.has(node.id);
    var opacity = isFaded ? depth === 1 ? 0.1 : 0.05 : 1.0; //
    ctx.globalAlpha = opacity;
    if (!isActiveNode && (node === hoverNode || highlightNodes.has(node.id))) {
      ctx.beginPath();
      ctx.arc(node.x, node.y, NODE_R * 1.05, 0, 2 * Math.PI, false);
      ctx.fillStyle = (_a = theme.light) === null || _a === void 0 ? void 0 : _a.color.primary;
      ctx.fill();
    }
    // draw the background
    ctx.fillStyle = '#FFFFFF';
    ctx.beginPath();
    ctx.arc(node.x, node.y, NODE_R, 0, 360);
    ctx.fill();
    var fillColor = node.nodeColor || (node.isCurrent || isGroupNode ? (_b = theme.light) === null || _b === void 0 ? void 0 : _b.color.primary : "#000000");
    var strokeColor = node.isCurrent ? (_c = theme.light) === null || _c === void 0 ? void 0 : _c.color.primary : "#AAAAAA";
    if (node.imageObject && (0, is_valid_image_url_1.isValidImageUrl)(node.image)) {
      ctx.save();
      // draw border around active node
      pathEllipse(ctx, node.x - iconWidth / 2, node.y - iconWidth / 2, iconWidth, iconWidth);
      ctx.strokeStyle = strokeColor;
      ctx.clip();
      if (imageStyle === 'logo') {
        var ratio = node.imageWidth / node.imageHeight;
        var pad = isActiveNode ? 1.5 : 1.15;
        var paddedWidth = iconWidth - pad;
        var dWidth = node.imageWidth > node.imageHeight ? paddedWidth : paddedWidth * ratio;
        var dHeight = node.imageWidth > node.imageHeight ? paddedWidth / ratio : paddedWidth;
        var dx = dWidth / 2;
        var dy = dHeight / 2;
        ctx.drawImage(node.imageObject, node.x - dx, node.y - dy, dWidth, dHeight);
      } else {
        var sx = node.imageHeight > node.imageWidth ? 0 : (node.imageWidth - node.imageHeight) / 2;
        var sy = node.imageHeight > node.imageWidth ? (node.imageHeight - node.imageWidth) / 2 : 0;
        var sWidth = node.imageHeight > node.imageWidth ? node.imageWidth : node.imageHeight;
        var sHeight = node.imageHeight > node.imageWidth ? node.imageWidth : node.imageHeight;
        ctx.drawImage(node.imageObject, sx, sy, sWidth, sHeight, node.x - iconWidth / 2, node.y - iconWidth / 2, iconWidth, iconWidth);
      }
      if (isActiveNode) {
        ctx.lineWidth = 0.8;
        ctx.stroke();
        ctx.lineWidth = 0.75;
        ctx.strokeStyle = '#FFFFFF';
        ctx.stroke();
        ctx.strokeStyle = (_d = theme.light) === null || _d === void 0 ? void 0 : _d.color.primary;
        ctx.lineWidth = 0.2;
        ctx.stroke();
      } else {
        ctx.lineWidth = 0.1;
        ctx.stroke();
      }
      ctx.restore();
    } else {
      if (isGroupNode) {
        ctx.lineWidth = 0.95;
        ctx.stroke();
        ctx.lineWidth = 0.85;
        ctx.strokeStyle = '#FFFFFF';
        ctx.stroke();
        ctx.strokeStyle = (_e = theme.light) === null || _e === void 0 ? void 0 : _e.color.primary;
        ctx.lineWidth = 0.80;
        ctx.stroke();
        ctx.lineWidth = 0.70;
        ctx.strokeStyle = '#FFFFFF';
        ctx.stroke();
      }
      // draw the icon 
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = fillColor;
      ctx.fillText(iconLabel, node.x, node.y);
    }
    var scalingFactor = isActiveNode || isGroupNode ? 1 / 12 : 1 / 9;
    var fontSize = scalingFactor * globalScaleWithMax * node.size;
    // draw the text label
    if (!isFaded) {
      ctx.font = "".concat(isActiveNode ? 500 : 400, " ").concat(fontSize, "px IBM Plex Sans");
      var textWidth = ctx.measureText(label).width;
      var bckgDimensions = [textWidth + fontSize * 0.5, fontSize + fontSize * 0.5]; // some padding
      // const bckgDimensions: number[] = [textWidth, fontSize].map(n => n + fontSize * 1.0); // some padding
      var y = node.y + iconWidth / 2 + (isActiveNode ? 2.6 : 2.5);
      ctx.fillStyle = false ? (_f = theme.light) === null || _f === void 0 ? void 0 : _f.color.primary : 'rgba(255, 255, 255, 1.0)';
      // @ts-ignore
      roundRect(ctx, node.x - bckgDimensions[0] / 2, y - bckgDimensions[1] / 2, bckgDimensions[0], bckgDimensions[1], bckgDimensions[1] / 2.2, true, false);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = false ? '#ffffff' : fillColor;
      ctx.fillText(label, node.x, y);
      if (entityTypeLabel) {
        var fontScale = isActiveNode ? 0.65 : 0.75;
        ctx.font = "".concat(fontSize * fontScale, "px IBM Plex Sans");
        var entityTextWidth = ctx.measureText(entityTypeLabel).width;
        var ebckgDimensions = [entityTextWidth + fontSize * 0.7, fontSize + fontSize * 0.2]; // some padding: ;
        var ey = node.y + iconWidth / 2 + 1.1;
        ctx.fillStyle = 'rgba(255, 255, 255, 1.0)';
        // @ts-ignore
        roundRect.apply(void 0, __spreadArray(__spreadArray([ctx, node.x - ebckgDimensions[0] / 2, ey - ebckgDimensions[1] / 2], __read(ebckgDimensions), false), [ebckgDimensions[1] / 2.2, true, false], false));
        // draw the entity type
        ctx.fillStyle = isGroupNode ? (_g = theme.light) === null || _g === void 0 ? void 0 : _g.color.primary : (_h = theme.light) === null || _h === void 0 ? void 0 : _h.color.textMid;
        ctx.fillText(entityTypeLabel, node.x, ey);
      }
    }
    ctx.globalAlpha = 1.0;
  };
};
var drawLink = function (_a) {
  var theme = _a.theme,
    highlightLinks = _a.highlightLinks;
  return function (link, ctx, globalScale) {
    var _a;
    var globalScaleWithMax = Math.min(globalScale, 12.5);
    var fontSize = 1 / 15 * globalScaleWithMax;
    // draw the text label
    var label = link.label && link.label.text;
    if (label) {
      ctx.font = "".concat(fontSize, "px IBM Plex Sans");
      var textWidth = ctx.measureText(label).width;
      var bckgDimensions = [textWidth, fontSize].map(function (n) {
        return n + fontSize * 0.4;
      }); // some padding
      var sx = link.source && link.source.x || 0;
      var sy = link.source && link.source.y || 0;
      var tx = link.target && link.target.x || 0;
      var ty = link.target && link.target.y || 0;
      var cx = (tx - sx) / 2;
      var cy = (ty - sy) / 2;
      var x = tx - cx;
      var y = ty - cy;
      // if there are highlighted links, and this one isn't included, don't draw the label
      if (!(!highlightLinks.has(link) && highlightLinks.size)) {
        ctx.fillStyle = 'rgba(255, 255, 255, 1.0)';
        // @ts-ignore
        ctx.fillRect.apply(ctx, __spreadArray([x - bckgDimensions[0] / 2, y - bckgDimensions[1] / 2], __read(bckgDimensions), false));
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = highlightLinks.has(link) ? (_a = theme.light) === null || _a === void 0 ? void 0 : _a.color.primary : '#AAA';
        ctx.fillText(label, x, y);
      }
    }
  };
};
var isGraphLink = function (item) {
  return item.kind === 'edge';
};
exports.isGraphLink = isGraphLink;
var isGraphNode = function (item) {
  return item.kind === 'node';
};
exports.isGraphNode = isGraphNode;
exports.EntityGraphDefaultProps = {
  onNodeClick: function () {},
  onRefChange: function () {},
  onLinkClick: function () {},
  highlightEntityTypeNames: [],
  imageWidth: 4000,
  useGroups: false,
  imageHeight: 4000,
  pageSize: 12,
  usePagination: false,
  pageSizeFullScreen: 16,
  linkItemOptions: {
    showImplicitLabels: true
  },
  nodeItemOptions: {},
  loading: false,
  velocityDecay: 0.5,
  onZoom: function () {}
};
// -------- Styles -------->
var FADE_SIZE = 18;
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 100%;\n    width: 100%;\n    display: flex;\n    position: relative;\n    flex-direction: column;\n  "], ["\n    height: 100%;\n    width: 100%;\n    display: flex;\n    position: relative;\n    flex-direction: column;\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-shrink: 0;\n    /* border-top: 1px solid ", "; */\n  "], ["\n    flex-shrink: 0;\n    /* border-top: 1px solid ", "; */\n  "])), theme_2.theme.COLOR('line-subtle'))
});
var LayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  "])))
});
var IconButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var PaginationControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    font-size: ", ";\n    padding: ", " ", ";\n    ", "\n  "], ["\n    display: flex;\n    justify-content: space-between;\n    font-size: ", ";\n    padding: ", " ", ";\n    ", "\n  "])), theme_2.theme.FONT_SIZE(12), theme_2.theme.UNIT(2), theme_2.theme.UNIT(2), function (props) {
    return props.isFullScreen && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), theme_2.theme.FONT_SIZE(16));
  })
});
var ControlItemStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme_2.theme.UNIT(4), theme_2.theme.UNIT(4))
});
var StartControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var EndControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var StylingStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    height: 100%;\n    display: flex;\n    width: 100%;\n    cursor: grab;\n\n    &.on-node {\n      canvas {\n        cursor: pointer !important;\n      }\n    }\n\n  "], ["\n    height: 100%;\n    display: flex;\n    width: 100%;\n    cursor: grab;\n\n    &.on-node {\n      canvas {\n        cursor: pointer !important;\n      }\n    }\n\n  "])))
});
// const RGBA = `rgba(255, 255, 255, 0.8)`;
var RGBA = "rgba(255, 255, 255, 0.8)";
var EntityTogglesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    position: absolute;\n    top: 0px;\n    left: 4px;\n    display: flex;\n    width: 48px;\n    z-index: 70;\n    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 20%, rgba(255, 255, 255, 0.8) 80%, rgba(255, 255, 255, 0.0) 100% );\n    flex-shrink: 0; \n    flex-direction: column;\n    justify-content: flex-start;\n    box-sizing: border-box;\n    padding: 0 0 ", " ", ";\n    font-weight: 500;\n    color: ", ";\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  "], ["\n    position: absolute;\n    top: 0px;\n    left: 4px;\n    display: flex;\n    width: 48px;\n    z-index: 70;\n    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 20%, rgba(255, 255, 255, 0.8) 80%, rgba(255, 255, 255, 0.0) 100% );\n    flex-shrink: 0; \n    flex-direction: column;\n    justify-content: flex-start;\n    box-sizing: border-box;\n    padding: 0 0 ", " ", ";\n    font-weight: 500;\n    color: ", ";\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  "])), theme_2.theme.UNIT(1), theme_2.theme.UNIT(4), theme_2.theme.COLOR('text')),
  tablet: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    width: 180px;\n  "], ["\n    width: 180px;\n  "])))
});
var EntityToggleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    cursor: pointer;\n    padding: ", " ", " ", " ", ";\n  "], ["\n    cursor: pointer;\n    padding: ", " ", " ", " ", ";\n  "])), theme_2.theme.UNIT(4), theme_2.theme.UNIT(1), theme_2.theme.UNIT(0), theme_2.theme.UNIT(1))
});
var CountStyles = (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  span {\n    display: inline-block;\n    padding: 0 ", ";\n  }\n\n  b {\n    font-weight: 500;\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n\n  span {\n    display: inline-block;\n    padding: 0 ", ";\n  }\n\n  b {\n    font-weight: 500;\n    color: ", ";\n  }\n"])), theme_2.theme.UNIT(1), theme_2.theme.COLOR('primary'));
var PageCountsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    ", ";\n    margin-right: ", ";\n  "], ["\n    ", ";\n    margin-right: ", ";\n  "])), CountStyles, theme_2.theme.UNIT(2))
});
var ItemCountsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    margin-left: ", ";\n    ", ";\n  "], ["\n    margin-left: ", ";\n    ", ";\n  "])), theme_2.theme.UNIT(2), CountStyles)
});
var GraphContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), props._height);
  })
});
var GraphBodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n  "], ["\n    position: relative;\n    width: 100%;\n  "])))
});
var FadeStyles = (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  position: absolute;\n  z-index: 50;\n"], ["\n  position: absolute;\n  z-index: 50;\n"])));
var TopFadeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    ", ";\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: ", "px;\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 0) 100%);\n  "], ["\n    ", ";\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: ", "px;\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 0) 100%);\n  "])), FadeStyles, FADE_SIZE)
});
var BottomFadeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    ", ";\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: ", "px;\n    background: linear-gradient(to top, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 0) 100%);\n  "], ["\n    ", ";\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: ", "px;\n    background: linear-gradient(to top, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 0) 100%);\n  "])), FadeStyles, FADE_SIZE)
});
var LeftFadeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    ", ";\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: ", "px;\n    background: linear-gradient(to right, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 0) 100%);\n  "], ["\n    ", ";\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: ", "px;\n    background: linear-gradient(to right, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 0) 100%);\n  "])), FadeStyles, FADE_SIZE)
});
var RightFadeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    ", ";\n    top: 0;\n    right: 0;\n    height: 100%;\n    width: ", "px;\n    background: linear-gradient(to left, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 0) 100%);\n  "], ["\n    ", ";\n    top: 0;\n    right: 0;\n    height: 100%;\n    width: ", "px;\n    background: linear-gradient(to left, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 0) 100%);\n  "])), FadeStyles, FADE_SIZE)
});
var TooltipStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    position: absolute;\n    padding: ", " ", ";\n    background: linear-gradient(to top, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 1.0) 80%, rgba(255, 255, 255, 0) 100%);\n    box-sizing: border-box;    \n    z-index: 100;\n    height: 100%;\n    width: 300px;\n    top: 0;\n    right: -1500px;\n    transition: right 0.8s;\n\n    ", "\n  "], ["\n    position: absolute;\n    padding: ", " ", ";\n    background: linear-gradient(to top, rgba(255, 255, 255, 1.0) 0%, rgba(255, 255, 255, 1.0) 80%, rgba(255, 255, 255, 0) 100%);\n    box-sizing: border-box;    \n    z-index: 100;\n    height: 100%;\n    width: 300px;\n    top: 0;\n    right: -1500px;\n    transition: right 0.8s;\n\n    ", "\n  "])), theme_2.theme.UNIT(4), theme_2.theme.UNIT(5), function (_a) {
    var isVisible = _a.isVisible;
    return isVisible && (0, styled_components_1.css)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n      right: 0;\n    "], ["\n      right: 0;\n    "])));
  })
});
var IdleMessageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    width: 100%;\n    justify-content: center;\n    border: none;\n    background: #FFF;\n    padding: ", ";\n  "], ["\n    width: 100%;\n    justify-content: center;\n    border: none;\n    background: #FFF;\n    padding: ", ";\n  "])), theme_2.theme.UNIT(8))
});
// -------- Components -------->
var My = {
  Layout: styled_components_1.default.div(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Styling: styled_components_1.default.div(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), StylingStyles),
  Container: styled_components_1.default.div(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  IconButton: (0, styled_components_1.default)(icon_button_1.IconButton)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), IconButtonStyles),
  Body: styled_components_1.default.div(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Controls: styled_components_1.default.div(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  ControlItem: styled_components_1.default.div(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), ControlItemStyles),
  PaginationControls: styled_components_1.default.div(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), PaginationControlsStyles),
  StartControls: styled_components_1.default.div(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), StartControlsStyles),
  EndControls: styled_components_1.default.div(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), EndControlsStyles),
  EntityToggles: styled_components_1.default.div(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), EntityTogglesStyles),
  EntityToggle: (0, styled_components_1.default)(entity_toggle_1.EntityToggle)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), EntityToggleStyles),
  PageCounts: styled_components_1.default.span(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), PageCountsStyles),
  ItemCounts: styled_components_1.default.span(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), ItemCountsStyles),
  GraphContainer: styled_components_1.default.div(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), GraphContainerStyles),
  Tooltip: (0, styled_components_1.default)(entity_tooltip_1.EntityTooltip)(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), TooltipStyles),
  GraphBody: styled_components_1.default.div(templateObject_45 || (templateObject_45 = __makeTemplateObject(["", ""], ["", ""])), GraphBodyStyles),
  TopFade: styled_components_1.default.div(templateObject_46 || (templateObject_46 = __makeTemplateObject(["", ""], ["", ""])), TopFadeStyles),
  BottomFade: styled_components_1.default.div(templateObject_47 || (templateObject_47 = __makeTemplateObject(["", ""], ["", ""])), BottomFadeStyles),
  LeftFade: styled_components_1.default.div(templateObject_48 || (templateObject_48 = __makeTemplateObject(["", ""], ["", ""])), LeftFadeStyles),
  RightFade: styled_components_1.default.div(templateObject_49 || (templateObject_49 = __makeTemplateObject(["", ""], ["", ""])), RightFadeStyles),
  IdleMessage: (0, styled_components_1.default)(alert_message_1.AlertMessage)(templateObject_50 || (templateObject_50 = __makeTemplateObject(["", ""], ["", ""])), IdleMessageStyles)
};
var EntityGraph = function (props) {
  var className = props.className,
    onNodeClick = props.onNodeClick,
    onRefChange = props.onRefChange,
    sid = props.sid,
    graph = props.graph,
    height = props.height,
    width = props.width,
    linkItemOptions = props.linkItemOptions,
    nodeItemOptions = props.nodeItemOptions,
    depth = props.depth,
    usePagination = props.usePagination,
    imageWidth = props.imageWidth,
    loading = props.loading,
    velocityDecay = props.velocityDecay,
    zoomed = props.zoomed,
    onZoom = props.onZoom,
    highlightEntityTypeNames = props.highlightEntityTypeNames;
  var pageSize = depth === 1 ? props.pageSize : 100;
  var pageSizeFullScreen = depth === 1 ? props.pageSizeFullScreen : 100;
  var entities = (0, use_entities_1.useEntities)();
  var t = (0, use_lang_1.useLang)();
  var stylingRef = (0, react_1.useRef)();
  var groupEdgesSet = new Set();
  var _a = __read((0, react_1.useState)(new Set()), 2),
    highlightNodes = _a[0],
    setHighlightNodes = _a[1];
  var _b = __read((0, react_1.useState)(new Set()), 2),
    highlightLinks = _b[0],
    setHighlightLinks = _b[1];
  var _c = __read((0, react_1.useState)(null), 2),
    hoverNode = _c[0],
    setHoverNode = _c[1];
  var EMPTY_ENTITY = {
    id: 'NONE',
    __typename: 'Person'
  };
  var _d = __read((0, react_1.useState)(EMPTY_ENTITY), 2),
    tooltipEntity = _d[0],
    setTooltipEntity = _d[1];
  // const [tooltipTimeout, setTooltipTimeout] = useState<any>(null);
  // const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(null);
  var updateHighlight = function () {
    setHighlightNodes(highlightNodes);
    setHighlightLinks(highlightLinks);
  };
  var _e = __read((sid || '').split('/'), 2),
    entityTypeSlug = _e[0],
    slug = _e[1];
  var entityTypeName = entityTypeSlug && (0, title_case_1.titleCase)(entityTypeSlug);
  var definition = entityTypeName && entities[entityTypeName];
  var connections = definition && definition.connections || {};
  var activeEntityTypes = connections && connections.activeEntityTypes || [];
  var entityTypeOrder = connections && connections.activeEntityTypes || [];
  var useGroups = connections.useGroups || props.useGroups || depth > 1;
  var dagMode = connections.dagMode,
    dagLevelDistance = connections.dagLevelDistance,
    d3VelocityDecay = connections.d3VelocityDecay,
    _f = connections.linkCurvature,
    linkCurvature = _f === void 0 ? 0.18 : _f,
    _g = connections.cooldownTime,
    cooldownTime = _g === void 0 ? 500 : _g;
  var Icons = (0, use_icons_1.useIcons)();
  var isFullScreen = (0, use_full_screen_state_1.useFullScreenState)().isFullScreen;
  var effectivePageSize = isFullScreen ? pageSizeFullScreen : pageSize;
  var _h = __read((0, use_dimensions_1.useDimensions)(), 2),
    controlsRef = _h[0],
    controlsDimensions = _h[1];
  var theme = (0, use_theme_1.useTheme)();
  var lineColor = (0, lodash_1.get)(theme, 'color.primary', '#CCC');
  var context = {
    theme: theme,
    entities: entities,
    depth: depth,
    hoverNode: hoverNode,
    highlightEntityTypeNames: highlightEntityTypeNames,
    highlightLinks: highlightLinks,
    highlightNodes: highlightNodes,
    linkItemOptions: linkItemOptions,
    nodeItemOptions: nodeItemOptions,
    sid: sid,
    dagMode: dagMode
  };
  var idleTimer = (0, react_idle_timer_1.useIdleTimer)({
    onIdle: function () {
      setState(__assign(__assign({}, state), {
        isIdle: true
      }));
    },
    onActive: function () {
      setState(__assign(__assign({}, state), {
        isIdle: false
      }));
    },
    timeout: 1000 * 60 * 2
  });
  var getNodeItem = nodeItem(context);
  var getLinkItem = linkItem(context);
  var controlsHeight = controlsDimensions.height || 0;
  // useEffect(() => {
  //   if (tooltipEntity && tooltipEntity.id === 'NONE') {
  //     setIsTooltipVisible(false);
  //   }
  // }, [tooltipEntity])
  var fgRef = (0, react_1.useRef)();
  var graphRef = (0, react_1.useRef)();
  var _j = __read((0, react_1.useState)({
      page: 0,
      activeEntityTypes: [],
      expandedGroups: {}
    }), 2),
    state = _j[0],
    setState = _j[1];
  (0, react_1.useEffect)(function () {
    setState({
      page: 0,
      activeEntityTypes: activeEntityTypes.length ? activeEntityTypes : (0, lodash_1.keys)(entityTypeCounts),
      expandedGroups: {}
    });
  }, [graph]);
  (0, react_1.useEffect)(function () {
    onRefChange(fgRef);
  }, [fgRef]);
  var page = state.page;
  var graphState = (0, react_1.useMemo)(function () {
    highlightNodes.clear();
    var nodes = graph.nodes,
      edges = graph.edges;
    var entityTypeCounts = (0, lodash_1.countBy)((0, lodash_1.tail)(nodes) || [], function (node) {
      return node.data.entityTypeName;
    });
    var entityToggles = (0, lodash_1.sortBy)((0, lodash_1.keys)((0, lodash_1.groupBy)((0, lodash_1.tail)(nodes) || [], function (node) {
      return node.data.entityTypeName;
    })), function (entityTypeName) {
      var index = entityTypeOrder.indexOf(entityTypeName);
      return index === -1 ? 99999 : index;
    });
    // this point is where the grouping should happen
    // Grouping should:
    // * Add additional grouping nodes one for each data.group in the set of nodes
    // * Redirect all links pointing at any nodes with data.group to the group nodes instead
    // * Also add a link from the group node to the original linked node
    // * Filter out any nodes where the group is not currently "open" in state
    // Grouping NODES:
    // * onClick should toggle the state of the node to open. The algorithm above should then hopefully take care of the expansion
    // * Closed nodes should have some kind of visual difference to open nodes. Perhaps initially we just do a thicker border
    //   but eventually I would like to have a radial representation of the underlying node images for closed nodes, and just the icon
    //   for open nodes
    var items = {
      top: !!nodes.length && getNodeItem(nodes[0]),
      nodes: (0, lodash_1.uniqBy)(nodes.slice(1, nodes.length).map(getNodeItem), 'id'),
      edges: (0, lodash_1.uniqBy)(edges.map(getLinkItem), 'id')
    };
    // establish collection of edges coming FROM group nodes
    var groupEdges = [];
    var groupNodes = [];
    var nodesByGroup = {};
    if (useGroups) {
      var nodesByGroup_1 = (0, lodash_1.groupBy)((0, lodash_1.filter)(items.nodes, function (node) {
        var group = (0, lodash_1.get)(node, 'data.group');
        if (group) {
          if (state.activeEntityTypes.length && !(0, lodash_1.includes)(state.activeEntityTypes, group.entityTypeName)) {
            return false;
          }
          return true;
        }
        return false;
      }), 'data.group.id');
      var groups = (0, lodash_1.uniqBy)((0, lodash_1.filter)(nodes.map(function (node) {
        return node.data.group;
      })), 'id');
      groupNodes = groups.map(function (group) {
        var lineColor = (0, lodash_1.get)(theme, 'color.primary', '#CCC');
        var isActive = !!state.expandedGroups[group.id];
        var groupDefn = entities[group.entityTypeName];
        return {
          id: group.id,
          neighbors: [],
          links: [],
          entityTypeLabel: groupDefn.countLabel({
            t: t,
            count: (nodesByGroup_1[group.id] || []).length
          }).toUpperCase(),
          type: group.entityTypeName,
          entityTypeName: group.entityTypeName,
          sortKey: "".concat(group.entityTypeName).concat(group.label),
          kind: 'node',
          isCurrent: false,
          border: isActive && {
            color: lineColor,
            width: 2
          },
          data: {
            group: group,
            isGroupNode: true,
            isActiveGroupNode: isActive
          },
          color: 'transparent',
          cutout: true,
          label: {
            backgroundColor: 'transparent',
            text: '',
            center: false
          },
          openGraph: {},
          size: 0.7
        };
      });
      items.edges = items.edges.map(function (edge) {
        var groupedEdge = __assign({}, edge);
        (0, lodash_1.forEach)(nodesByGroup_1, function (nodes, groupId) {
          (0, lodash_1.forEach)(nodes, function (node) {
            if (edge.id1 === node.id) {
              groupedEdge.id1 = groupId;
              groupedEdge.type = 'group-edge';
              /* @ts-ignore */
              groupedEdge.label = {};
            }
            if (edge.id2 === node.id) {
              groupedEdge.id2 = groupId;
              groupedEdge.type = 'group-edge';
              /* @ts-ignore */
              groupedEdge.label = {};
            }
            if ((0, lodash_1.includes)([edge.id2, edge.id1], node.id)) {
              // only create edges to destination nodes if the group is expanded
              // if (state.expandedGroups[groupId]) {
              // applied = applied + 1;
              /* @ts-ignore */
              groupEdges.push({
                id: "".concat(groupId, "/").concat(node.id),
                data: {},
                id1: groupId,
                id2: node.id,
                label: edge.label.text,
                isImplicit: true
              });
              // }
            }
          });
        });
        return groupedEdge;
      });
      // console.log(groupNodes);
      // console.log(items);
      // now apply groups by redirecting nodes pointing to another node with a group to the group node instead
      /*
      const edgesById1 = groupBy(items.edges, 'id1');
      const edgesById2 = groupBy(items.edges, 'id2');
                 console.log(edgesById2);
      */
    }
    var filteredNodes = (0, lodash_1.filter)(items.nodes, function (node) {
      return (0, lodash_1.includes)(state.activeEntityTypes, node.entityTypeName);
    });
    var pages = Math.ceil((filteredNodes.length || 0) / effectivePageSize);
    var start = page * effectivePageSize;
    var totalItems = filteredNodes.length;
    var end = Math.min(totalItems, (page + 1) * effectivePageSize);
    var pageNodes = usePagination ? (0, lodash_1.sortBy)(filteredNodes, 'sortKey').slice(start, end) : (0, lodash_1.sortBy)(filteredNodes, 'sortKey');
    var graphDataNodes = items.top ? __spreadArray(__spreadArray([items.top], __read(pageNodes), false), __read(groupNodes), false) : [];
    var graphNodesById = (0, lodash_1.keyBy)(graphDataNodes, 'id');
    var ret = {
      pages: pages,
      start: start,
      end: end,
      nodesByGroup: nodesByGroup,
      pageNodes: pageNodes,
      entityTypeCounts: entityTypeCounts,
      entityToggles: entityToggles,
      graphNodesById: graphNodesById,
      totalItems: totalItems,
      graphData: {
        nodes: graphDataNodes,
        links: __spreadArray(__spreadArray([], __read((0, lodash_1.uniqBy)((0, lodash_1.filter)(items.edges, function (edge) {
          return !!graphNodesById[edge.id1] && !!graphNodesById[edge.id2];
        }), function (edge) {
          return [edge.id1, edge.id2].sort().join('');
        })), false), __read((0, lodash_1.uniqBy)(groupEdges, 'id').map(getLinkItem)), false)
      }
    };
    return ret;
  }, [sid, depth, loading, graph, state]);
  var pages = graphState.pages,
    start = graphState.start,
    end = graphState.end,
    graphData = graphState.graphData,
    totalItems = graphState.totalItems,
    entityTypeCounts = graphState.entityTypeCounts,
    entityToggles = graphState.entityToggles;
  var linksBySource = (0, lodash_1.keyBy)(graphData.links, 'id1');
  var linksByTarget = (0, lodash_1.keyBy)(graphData.links, 'id2');
  // multi-pass on nodes, now we filter again if there are no edges from or to this node
  graphData.nodes = (0, lodash_1.filter)(graphData.nodes, function (node) {
    return node.id === sid || !!linksBySource[node.id] || !!linksByTarget[node.id];
  });
  graphData.nodesById = (0, lodash_1.keyBy)(graphData.nodes, 'id');
  // cross-link node objects
  graphData.links.forEach(function (link) {
    var a = graphData.nodesById[link.id1];
    var b = graphData.nodesById[link.id2];
    if (a && b) {
      !a.neighbors && (a.neighbors = []);
      !b.neighbors && (b.neighbors = []);
      a.neighbors.push(b);
      b.neighbors.push(a);
      !a.links && (a.links = []);
      !b.links && (b.links = []);
      a.links.push(link);
      b.links.push(link);
    }
  });
  var onNodeHover = function (node) {
    var stylingContainer = stylingRef && stylingRef.current;
    if (node) {
      if (fgRef && fgRef.current) {
        var coords = fgRef.current.graph2ScreenCoords(node.x, node.y);
        var data = node.data,
          _a = node.openGraph,
          openGraph = _a === void 0 ? {} : _a;
        var x = coords.x,
          y = coords.y;
        var entity = {
          id: data.entityId,
          __typename: data.entityTypeName,
          name: openGraph && openGraph.title,
          openGraph: __assign(__assign({}, openGraph), {
            description: {
              text: openGraph.description && openGraph.description.text && (0, truncate_words_1.truncateWords)(openGraph.description.text, {
                max: 140
              })
            }
          })
        };
        // setTooltipEntity(entity);
        // setIsTooltipVisible(true);
      }
    } else {
      setTooltipEntity(__assign(__assign({}, tooltipEntity || {}), {
        id: 'NONE'
      }));
    }
    if (!(0, lodash_1.isUndefined)(stylingContainer)) {
      // @ts-ignore 
      stylingContainer.classList.remove('on-node');
      if (node && node.id !== sid) {
        // @ts-ignore 
        stylingContainer.classList.add('on-node');
      }
    }
    highlightNodes.clear();
    highlightLinks.clear();
    if (node) {
      highlightNodes.add(node.id);
      node.neighbors.forEach(function (neighbor) {
        return highlightNodes.add(neighbor.id);
      });
      node.links.forEach(function (link) {
        return highlightLinks.add(link);
      });
    }
    setHoverNode(node || null);
    updateHighlight();
  };
  var onLinkHover = function (link) {
    highlightNodes.clear();
    highlightLinks.clear();
    if (link) {
      highlightLinks.add(link);
      // highlightNodes.add(link.id1);
      // highlightNodes.add(link.id2);
    }
    updateHighlight();
  };
  var firstPage = function () {
    setState(__assign(__assign({}, state), {
      page: 0
    }));
  };
  var lastPage = function () {
    setState(__assign(__assign({}, state), {
      page: pages - 1
    }));
  };
  var nextPage = function () {
    setState(__assign(__assign({}, state), {
      page: state.page + 1
    }));
  };
  var previousPage = function () {
    setState(__assign(__assign({}, state), {
      page: state.page - 1
    }));
  };
  var handleToggleClick = function (entityTypeName) {
    var newState = __assign(__assign({}, state), {
      page: 0,
      activeEntityTypes: (0, lodash_1.xor)(state.activeEntityTypes, [entityTypeName])
    });
    setState(newState);
  };
  var handleNodeClick = function (node, event) {
    var _a;
    var isGroupNode = (0, lodash_1.get)(node, 'data.isGroupNode');
    if (isGroupNode) {
      var group = node.data.group;
      setState(__assign(__assign({}, state), {
        expandedGroups: (_a = {},
        // ...state.expandedGroups,
        // [group.id]: !state.expandedGroups[group.id],
        _a[group.id] = true, _a)
      }));
    } else {
      onNodeClick({
        node: node
      });
    }
  };
  var hoverColor = "primary";
  var color = "dark";
  var iconRatio = 7 / 6;
  var iconSize = isFullScreen ? 26 : 18;
  var entityToggleIconSize = isFullScreen ? 32 : 22;
  var entityToggleFontSize = isFullScreen ? 16 : 12;
  var forceGraphHeight = height; // - controlsHeight;
  // console.log(graphData);
  return react_1.default.createElement(My.Styling, {
    ref: stylingRef
  }, react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Body, null, state.isIdle ? react_1.default.createElement(My.IdleMessage, {
    text: t('Connections view is idle to save energy. Move your pointer to resume.')
  }) : react_1.default.createElement(My.GraphContainer, {
    _height: forceGraphHeight
  }, react_1.default.createElement(My.EntityToggles, null, (0, lodash_1.map)(entityToggles, function (entityTypeName) {
    var entityConfig = entities[entityTypeName];
    var label = entityConfig && entityConfig.label;
    var pluralLabel = entityConfig && entityConfig.pluralLabel;
    if ((0, lodash_1.includes)(highlightEntityTypeNames, entityTypeName)) {
      return null;
    }
    return react_1.default.createElement(My.EntityToggle, {
      key: entityTypeName,
      fontSize: entityToggleFontSize,
      iconSize: entityToggleIconSize,
      // title={sprintf(t(count === 1 ? `%d ${label}` : `%d ${pluralLabel}`), count)}
      title: pluralLabel,
      onClick: function () {
        return handleToggleClick(entityTypeName);
      },
      entityTypeName: entityTypeName,
      isOn: (0, lodash_1.includes)(state.activeEntityTypes, entityTypeName)
    });
  })), react_1.default.createElement(My.GraphBody, {
    ref: graphRef
  }, react_1.default.createElement(My.TopFade, null), react_1.default.createElement(My.BottomFade, null), react_1.default.createElement(My.LeftFade, null), react_1.default.createElement(My.RightFade, null), graphData && !!graphData.nodes.length && react_1.default.createElement(react_force_graph_2d_1.default, {
    ref: fgRef,
    nodeRelSize: 1.4,
    graphData: graphData,
    linkSource: "id1",
    linkTarget: "id2",
    width: width,
    minZoom: graphData.nodes.length === 1 ? 14 : 6,
    maxZoom: 18,
    d3VelocityDecay: d3VelocityDecay || velocityDecay,
    cooldownTime: cooldownTime,
    dagMode: dagMode,
    dagLevelDistance: dagLevelDistance,
    linkCurvature: linkCurvature,
    onNodeHover: onNodeHover,
    onNodeClick: handleNodeClick,
    linkDirectionalParticles: 4,
    linkDirectionalParticleSpeed: 0.003,
    linkDirectionalParticleWidth: function (link) {
      return highlightLinks.has(link) ? 1 : 0.1;
    },
    linkCanvasObjectMode: function () {
      return "after";
    },
    backgroundColor: '#FFF',
    height: forceGraphHeight,
    // onLinkHover={onLinkHover}
    nodeVal: function () {
      return 5;
    },
    nodeColor: function () {
      return '#CCC';
    },
    linkLineDash: function (link) {
      return !(highlightLinks.has(link) || link.type === 'group-edge') && [0.125, 0.125];
    },
    linkWidth: function (link) {
      return highlightLinks.has(link) || link.type === 'group-edge' ? 1.5 : depth > 1 && highlightLinks.size ? 0.01 : 0.5;
    },
    linkColor: function (link) {
      var _a;
      return highlightLinks.has(link) || link.type === 'group-edge' ? (_a = theme.light) === null || _a === void 0 ? void 0 : _a.color.primary : highlightLinks.size ? '#DDD' : '#C7C7C7';
    },
    onEngineStop: function () {
      if (fgRef && fgRef.current && !zoomed) {
        var fit = 30;
        if (graphData.nodes.length > 4) {
          fit = 60;
        }
        if (graphData.nodes.length === 1) {
          fit = (height - 50) / 2;
        }
        if (graphData.nodes.length === 2) {
          fit = 120;
        }
        // @ts-ignore
        fgRef.current.zoomToFit(400, fit);
        // // fgRef.current.zoom(12, 400);
        // console.log(graphData);
        // const centerNode = graphData.nodes.length && graphData.nodes[0];
        onZoom();
        // if (centerNode) {
        //   fgRef.current.centerAt(centerNode.vx, centerNode.vy);
        // }
      }
    },
    nodeCanvasObject: drawNode(context),
    linkCanvasObject: drawLink(context)
  })))), usePagination && react_1.default.createElement(My.Controls, {
    ref: controlsRef
  }, react_1.default.createElement(My.PaginationControls, {
    isFullScreen: isFullScreen
  }, react_1.default.createElement(My.StartControls, null, react_1.default.createElement(My.ControlItem, null, react_1.default.createElement(My.IconButton, {
    iconSize: iconSize,
    iconRatio: iconRatio,
    disabled: page === 0,
    hoverColor: hoverColor,
    icon: react_1.default.createElement(Icons.ChevronDoubleLeft, null),
    color: color,
    onClick: firstPage
  })), react_1.default.createElement(My.ControlItem, null, react_1.default.createElement(My.IconButton, {
    iconSize: iconSize,
    disabled: page === 0,
    hoverColor: hoverColor,
    icon: react_1.default.createElement(Icons.ChevronLeft, null),
    color: color,
    onClick: previousPage
  })), react_1.default.createElement(My.ItemCounts, null, react_1.default.createElement("b", null, start + 1), react_1.default.createElement("span", null, "-"), react_1.default.createElement("b", null, end), react_1.default.createElement("span", null, "of"), react_1.default.createElement("b", null, totalItems), react_1.default.createElement("span", null, t("Items")))), react_1.default.createElement(My.EndControls, null, react_1.default.createElement(My.PageCounts, null, react_1.default.createElement("span", null, t('Page'), ":"), react_1.default.createElement("b", null, page + 1), react_1.default.createElement("span", null, "of"), react_1.default.createElement("b", null, pages)), react_1.default.createElement(My.ControlItem, null, react_1.default.createElement(My.IconButton, {
    iconSize: iconSize,
    disabled: page >= pages - 1,
    hoverColor: hoverColor,
    icon: react_1.default.createElement(Icons.ChevronRight, null),
    color: color,
    onClick: nextPage
  })), react_1.default.createElement(My.ControlItem, null, react_1.default.createElement(My.IconButton, {
    iconSize: iconSize,
    iconRatio: iconRatio,
    disabled: page >= pages - 1,
    icon: react_1.default.createElement(Icons.ChevronDoubleRight, null),
    hoverColor: hoverColor,
    color: color,
    onClick: lastPage
  })))))));
};
exports.EntityGraph = EntityGraph;
exports.EntityGraph.defaultProps = exports.EntityGraphDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50;